import React from 'react';

import { Author, Article } from '../../../../models/article';
import PopularBlockComponent from '../../PopularBlock';
import styled, { StylesProps } from '../../../../lib/styles';
import blockStyles from './Block_styles';
import { compose } from 'recompose';
import Spacer from '../../../../components/presentational/Spacer';
export interface PopularBlockData {
  type: 'popular_block';
  authors: Author[];
}

interface PopularBlockProps {
  block: PopularBlockData;
  popular: Article[];
}

const PopularBlock = ({
  block,
  popular,
  styles,
}: PopularBlockProps & StylesProps<typeof blockStyles>) => {
  return (
    <div className={styles.container}>
      <Spacer width={1160} space={['m', 'l']}>
        <PopularBlockComponent
          slotKey={'popular-stories'}
          articles={popular}
          authors={block.authors}
        />
      </Spacer>
    </div>
  );
};

export default compose(styled(blockStyles))(PopularBlock);
